import { PHONE, locationSchema } from "../structured-data-core";

export function getStLouisStructuredData() {
  const url = "https://restorehair.com/locations/missouri/st-louis/";
  const description =
    "Find out about your hair transplant options in St. Louis with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("St. Louis", "2 Cityplace Dr, 2nd Floor", "St. Louis", "MO", PHONE, url, description),
  ];
}
